import TrailProgramVue from '@/views/sa/trial-program/trial-program.vue';

const basePath = '/sa/trial-program';
const role = 'sa'; // 角色身份

export const SA_TRIAL_PROGRAM_INDEX = 'sa-trial-program-index';
// export const SA_EDIT_STOCK = 'sa-edit-stock';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: TrailProgramVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SA_TRIAL_PROGRAM_INDEX,
      component: () => import(
        /* webpackChunkName: "preselect" */
        `@/views/${role}/trial-program/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    // {
    //   path: `${basePath}/edit-stock`,
    //   name: SA_EDIT_STOCK,
    //   props: true,
    //   component: () => import(
    //     /* webpackChunkName: "reservation" */
    //     `@/views/${role}/stock/edit-stock.vue`
    //     ).catch(() => import('@/views/errors/404.vue')),
    //   meta: { requiresAuth: true }
    // }
  ]
};
